import { OpenFeature, TypedInMemoryProvider } from '@openfeature/web-sdk';

/**
 * Vendor-neutral flags via OpenFeature. The in-memory provider is the dev/test default;
 * point it at a hosted provider in production. Flag-gating is UX only — the server still
 * enforces real access (ARCHITECTURE §9).
 */
export function initFeatureFlags(): void {
  OpenFeature.setProvider(
    new TypedInMemoryProvider({
      'expense.optimistic': {
        disabled: false,
        variants: { on: true, off: false },
        defaultVariant: 'off',
      },
    }),
  );
}
